import React from 'react'
import './Contact.scss'

const Contact = () => {
    return (
        <section className="contact" id="contact">
            <h1 className="heading">
                <span>Contact</span> us
            </h1>

            <form action="#">

                <div className="inputBox">
                    <input type="text" placeholder="name" />
                    <input type="email" placeholder="email" />
                </div>

                <div className="inputBox">
                    <input type="number" placeholder="number" />
                    <input type="text" placeholder="subject" />
                </div>

                <textarea placeholder="message"></textarea>

                <input type="submit" className="btn" value="Send message" />
            </form>
        </section>
    )
}

export default Contact